import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../../shared/helper-components/modal/_services/modal.service';

import { CIAsset } from '../clearance-item.model';
import { IAssetProcessing } from "./asset-processing.interface";
import { AppService } from "../../app.service";
import { map } from 'rxjs/internal/operators/map';

@Injectable()
export class AssetImageProcessing implements IAssetProcessing {

    private _downloadStarted = new Subject<any>();
    private _downloadFinished = new Subject<any>();
    onDownloadStarted = this._downloadStarted.asObservable();
    onDownloadFinished = this._downloadFinished.asObservable();

    assetType(): string {
        return 'image';
    }

    supportedImages: string[] = ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'jpeg','jpg','png', 'bmp','heic','heif'];
    
    constructor(
        private modalService: ModalService,
        private _appService: AppService,
        private sanitizer: DomSanitizer) {
    }

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
      }

    downloadAsset(asset: CIAsset, projectId: string, ownerType: string, direct: boolean, tryViewInBrowser: boolean = false) {
        this._downloadStarted.next(direct);
        
        this._appService.getSignedUrl(encodeURIComponent(asset.url), projectId, 'GET', 'image', ownerType, encodeURIComponent(asset.name))
            .subscribe(signedUrl => {
                
                console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
                let downloadedAsset = Object.assign(new CIAsset(), asset);
                downloadedAsset.fullUrl = signedUrl.url;
                downloadedAsset.name = asset.name;
                this._downloadFinished.next({asset: downloadedAsset, direct: direct});
            });
    }

    processAsset(file: File, projectId: string, ownerType: string): Observable<CIAsset> {
        if (!this.supportedImages.find(f=> f === file.type)){
            return this._appService.getSignedUrl(encodeURIComponent(file.name), projectId, 'PUT', 'image', ownerType,'').pipe(
            map(signedUrl => {
                console.log('ImageProcessing.processAsset >> signed Url:' + signedUrl.url);

                let newAsset = new CIAsset();
                newAsset.name = file.name;
                newAsset.urlName = signedUrl.name;
                newAsset.id = signedUrl.name;
                newAsset.fullUrl = '../../../assets/images/attachment-icon.jpg';
                if (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) {
                    newAsset.fileType = "image/webp";
                } else {
                    newAsset.fileType = (file.type === "" ? "application/octet-stream" : file.type);
                }

                // Store upload info on the asset for the uploader to use
                (newAsset as any)._uploadUrl = signedUrl.url.toString();
                (newAsset as any)._uploadMethod = 'PUT';
                (newAsset as any)._uploadFile = file;

               return newAsset;
            })
            );
        }
        
        var reader = new FileReader();

        var thumbNail: string = '';

        return new Observable(observer => {

            reader.addEventListener("load", (event: any) => {
                var img = new Image();

                //let's wait until the image is fully loaded onto the DOM object
                img.addEventListener("load", (imgEvent: any) => {
                
                    //resize the image
                    thumbNail = this.createThumbnail(img, 64, file.type);
                    var originalSizeImage = this.createThumbnail(img, Math.max(img.height, img.width), file.type);
                    
                    //get the signed url to upload to aws
                    this._appService.getSignedUrl(encodeURIComponent(file.name), projectId, 'PUT', 'image', ownerType,'')
                        .subscribe(signedUrl => {
                            console.log('ImageProcessing.processAsset >> signed Url:' + signedUrl.url);

                            let newAsset = new CIAsset();
                            newAsset.name = file.name;
                            newAsset.urlName = signedUrl.name;
                            newAsset.id = signedUrl.name;
                            newAsset.fullUrl = thumbNail;
                            newAsset.originalImageFullUrl = originalSizeImage;
                            newAsset.fileType = file.type;

                            // Store upload info on the asset for the uploader to use
                            (newAsset as any)._uploadUrl = signedUrl.url.toString();
                            (newAsset as any)._uploadMethod = 'PUT';
                            (newAsset as any)._uploadFile = file;

                            //notify the listeners that this asset has been added to the loader queue
                            observer.next(newAsset);
                            observer.complete();
                        });

                });

                img.src = event.target.result;

            });
            
            reader.readAsDataURL(file);
        });
    }

    createThumbnail(img: any, MAX_Pixel: number = 64, imageType: string = 'image/jpeg') {        
        var canvas = document.createElement("canvas");
        var width = img.width;
        var height = img.height;
        var factor: number;
        if (width > height) {
            factor = MAX_Pixel / width;
        } else {
            factor = MAX_Pixel / height;
        }

        canvas.width = width * factor;
        canvas.height = height * factor;
        var ctx = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataUrl = canvas.toDataURL(imageType);
        return dataUrl;
    }
}
